import { gql } from "react-apollo";
import {
  ADMIN_UPDATE_STATIC_START,
  ADMIN_UPDATE_STATIC_SUCCESS,
  ADMIN_UPDATE_STATIC_ERROR,
} from "../../constants";
import history from "../../core/history";
import { toastr } from "react-redux-toastr";
import showToaster from "../../helpers/showToaster";

import {
  containsMalicious,
  containsMaliciousForEditor,
} from "../../helpers/textRestriction";

const mutation = gql`
  mutation updateStaticPage(
    $id: Int
    $content: String
    $metaTitle: String
    $metaDescription: String
  ) {
    updateStaticPage(
      id: $id
      content: $content
      metaTitle: $metaTitle
      metaDescription: $metaDescription
    ) {
      status
    }
  }
`;

const query = gql`
  query getEditStaticPage($id: Int!) {
    getEditStaticPage(id: $id) {
      id
      pageName
      content
      metaTitle
      metaDescription
      createdAt
    }
  }
`;

export function updateStaticPageAction(values) {
  return async (dispatch, getState, { client }) => {
    try {
      // Server-side input validation
      const { content, metaTitle, metaDescription } = values;

      if (
        (metaTitle && containsMalicious(metaTitle)) ||
        (metaDescription && containsMalicious(metaDescription))
      ) {
        showToaster({ messageId: "invalidInput", toasterType: "error" });
        dispatch({ type: ADMIN_UPDATE_STATIC_ERROR });
        return false;
      }

      if (
        !content ||
        content === "<p><br></p>" ||
        content === "<p> </p>" ||
        containsMaliciousForEditor(content)
      ) {
        showToaster({ messageId: "addContent", toasterType: "error" });
        dispatch({ type: ADMIN_UPDATE_STATIC_ERROR });
        return false;
      }

      dispatch({ type: ADMIN_UPDATE_STATIC_START });

      const { data } = await client.mutate({
        mutation,
        variables: {
          content,
          metaTitle,
          metaDescription,
          id: values.id,
        },
        refetchQueries: [{ query, variables: { id: values.id } }],
      });

      if (data.updateStaticPage.status === "success") {
        showToaster({ messageId: "updateStaticPage", toasterType: "success" });
        history.push("/siteadmin/staticpage/management");
        dispatch({ type: ADMIN_UPDATE_STATIC_SUCCESS });
      } else {
        showToaster({
          messageId: "updateStaticPageError",
          toasterType: "error",
        });
        dispatch({ type: ADMIN_UPDATE_STATIC_ERROR });
      }
    } catch (error) {
      showToaster({ messageId: "updateFailed", toasterType: "error" });
      dispatch({ type: ADMIN_UPDATE_STATIC_ERROR });
      return false;
    }

    return true;
  };
}
